import React from 'react';
import { Typography, Card, Layout, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { Content } = Layout;

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(145deg, #FAFBFE 0%, #F4F6FB 30%, #EEF2FA 100%)' }}>
      <Content style={{ padding: '24px 48px', maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ marginBottom: 24 }}>
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={() => navigate('/')}
            style={{ marginBottom: 16 }}
          >
            Back to Home
          </Button>
        </div>

        <Card style={{ boxShadow: '0 4px 16px rgba(139, 122, 174, 0.12)', borderRadius: 16 }}>
          <Title level={1} style={{ color: '#2D3748', marginBottom: 32 }}>Privacy Policy</Title>
          
          <Paragraph style={{ fontSize: '14px', color: '#718096', marginBottom: 32 }}>
            <strong>Last updated:</strong> {new Date().toLocaleDateString()}
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>1. Information We Collect</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            When you use Vouchain's B2B voucher marketplace, we collect the following information:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li><strong>Business Information:</strong> Company name, business license, tax ID, and authorized representative details</li>
            <li><strong>Account Information:</strong> Email address, username, password, and profile information</li>
            <li><strong>Transaction Data:</strong> Purchase history, voucher codes, payment information, and billing details</li>
            <li><strong>Technical Information:</strong> IP address, browser type, device information, and usage analytics</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>2. How We Use Your Information</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We use your information to:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Process your voucher orders and deliver digital products</li>
            <li>Verify your business credentials and maintain platform security</li>
            <li>Provide customer support and resolve disputes</li>
            <li>Improve our services and develop new features</li>
            <li>Send important notifications about your account and transactions</li>
            <li>Comply with legal obligations and prevent fraud</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>3. Information Sharing</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We may share your information with:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li><strong>Voucher Suppliers:</strong> Business details necessary for order fulfillment</li>
            <li><strong>Payment Processors:</strong> Financial information required for transaction processing</li>
            <li><strong>Service Providers:</strong> Third-party vendors who assist in platform operations</li>
            <li><strong>Legal Authorities:</strong> When required by law or to protect our rights</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>4. Data Security</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We implement industry-standard security measures including:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>SSL encryption for all data transmission</li>
            <li>Secure cloud storage with regular backups</li>
            <li>Multi-factor authentication for account access</li>
            <li>Regular security audits and vulnerability assessments</li>
            <li>Access controls limiting employee data access</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>5. Your Rights</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            You have the right to:
          </Paragraph>
          <ul style={{ color: '#4A5568', marginLeft: 16 }}>
            <li>Access and review your personal information</li>
            <li>Request corrections to inaccurate data</li>
            <li>Delete your account and associated data</li>
            <li>Export your data in a portable format</li>
            <li>Opt out of marketing communications</li>
            <li>Lodge complaints with data protection authorities</li>
          </ul>

          <Title level={2} style={{ color: '#2D3748' }}>6. Data Retention</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We retain your information for as long as necessary to provide our services and comply with legal obligations. 
            Transaction records are kept for 7 years for tax and audit purposes. Account information is deleted within 
            30 days of account closure unless required for legal compliance.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>7. International Transfers</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            Your data may be processed in countries other than your own. We ensure adequate protection through 
            standard contractual clauses and compliance with applicable data protection frameworks.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>8. Contact Us</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            If you have questions about this Privacy Policy or wish to exercise your rights, please contact us through our platform.
          </Paragraph>

          <Title level={2} style={{ color: '#2D3748' }}>9. Updates to This Policy</Title>
          <Paragraph style={{ color: '#4A5568' }}>
            We may update this Privacy Policy periodically. Material changes will be notified via email and 
            prominently displayed on our platform. Continued use of our services constitutes acceptance of the updated policy.
          </Paragraph>
        </Card>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicy; 